import { match } from 'ts-pattern'
import { PaymentProvider } from './payment'

export type WebDialogPaymentProvider =
  | PaymentProvider.onerway
  | PaymentProvider.onerwayJcbAeUnionPay
  | PaymentProvider.onerwayWechatPay
  | PaymentProvider.paypay
  | PaymentProvider.gmo

export type WebBackendPaymentProvider =
  | PaymentProvider.onerway
  | PaymentProvider.paypay
  | PaymentProvider.gmo

const ONE_TIME_MEMBERSHIP_PAYMENT_PROVIDERS: readonly WebDialogPaymentProvider[] =
  [
    PaymentProvider.paypay,
    PaymentProvider.gmo,
    PaymentProvider.onerwayWechatPay,
    PaymentProvider.onerwayJcbAeUnionPay,
  ]

export function toWebPaymentBackendProvider(
  provider: WebDialogPaymentProvider,
): WebBackendPaymentProvider {
  return match(provider)
    .returnType<WebBackendPaymentProvider>()
    .with(
      PaymentProvider.onerway,
      PaymentProvider.onerwayJcbAeUnionPay,
      PaymentProvider.onerwayWechatPay,
      () => PaymentProvider.onerway,
    )
    .with(PaymentProvider.paypay, () => PaymentProvider.paypay)
    .with(PaymentProvider.gmo, () => PaymentProvider.gmo)
    .otherwise(() => {
      throw new Error(`Unsupported web payment provider: ${provider as string}`)
    })
}

export function usesOneTimeMembershipItem(
  provider: WebDialogPaymentProvider,
): boolean {
  return ONE_TIME_MEMBERSHIP_PAYMENT_PROVIDERS.includes(provider)
}

export function isOnerwayCardPaymentProvider(
  provider: WebDialogPaymentProvider,
): provider is PaymentProvider.onerway | PaymentProvider.onerwayJcbAeUnionPay {
  return (
    provider === PaymentProvider.onerway ||
    provider === PaymentProvider.onerwayJcbAeUnionPay
  )
}
